import { Options } from './types/api'
import { transform } from './transform'

class ApiPlus {
    options: Options = {
        requestMethods: {}
    }
    constructor(options: Options = {}) {
        this.options = options
    }

    public transform<T>(requestUrlMap: T) {
        return transform(requestUrlMap, this.options)
    }
}

export default ApiPlus
